
<template>
  <div>
    <FindPassword></FindPassword>
  </div>
</template>

<script>
import FindPassword from "@/components/shoplus_service/partners/FindPassword.vue";

export default {
  components: {
    FindPassword
  }
};
</script>